import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
// import { IonicPageModule } from 'ionic-angular';
import { MyApp } from './app.component';
import { HttpClientModule } from '@angular/common/http';

// import { AboutPage } from '../pages/about/about';
import { ContactPage } from '../pages/contact/contact';
// import { StationsPage } from '../pages/stations/stations';
import { HomePage } from '../pages/home/home';
import { TabsPage } from '../pages/tabs/tabs';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Geolocation } from '@ionic-native/geolocation';

import { StationsProvider } from '../providers/stations/stations';
import { ItineraireProvider } from '../providers/itineraire/itineraire';
import { AnalyticsProvider } from '../providers/analytics/analytics';

@NgModule({
  declarations: [
    MyApp,
    // AboutPage,
    HomePage,
    ContactPage,
    // StationsPage,
    TabsPage
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    // IonicPageModule.forChild(StationsPage),
    IonicModule.forRoot(MyApp, { preloadModules: true }/*, {
      // locationStrategy : 'path'
      // tabsPlacement: 'top',
      // platforms: {
      //   mobile: {
      //     tabsPlacement:'bottom'
      //   }
      // }
    }, {
      // links: [
      //   { component: HomePage, name: 'Itinéraire', segment: 'home' },
      //   { component: StationsPage, name: 'Stations', segment: 'stations' },
      //   { component: AboutPage, name: 'A Propos', segment: 'about' }
      // ]
    }*/
    )
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    // AboutPage,
    HomePage,
    ContactPage,
    // StationsPage,
    TabsPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Geolocation,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    StationsProvider,
    ItineraireProvider,
    AnalyticsProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts